export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11007.435680f5.jpg";